import React from 'react'
import HrBadge from 'ui/hr-profile-ui-components/HrBadge';

const About = () => {
  return (
    <HrBadge />
  )
}

export default About